import { template as _$template } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=unbaked-list><table><thead><tr><th>Name</th><th>Type</th><th>Source</th><th>Reason</th></tr></thead><tbody>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<tr><td></td><td></td><td></td><td>`);
import { For } from "solid-js";
/** Honest coverage list: every real asset type with no bake stage yet, plus any file that failed to decode despite one. */
export function UnbakedList(props) {
  return (() => {
    var _el$ = _tmpl$(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.nextSibling;
    _$insert(_el$4, _$createComponent(For, {
      get each() {
        return props.entries;
      },
      children: entry => (() => {
        var _el$5 = _tmpl$2(),
          _el$6 = _el$5.firstChild,
          _el$7 = _el$6.nextSibling,
          _el$8 = _el$7.nextSibling,
          _el$9 = _el$8.nextSibling;
        _$insert(_el$6, () => entry.id.replace(/^unbaked\//, ""));
        _$insert(_el$7, () => entry.type);
        _$insert(_el$8, () => entry.sourcePath);
        _$insert(_el$9, () => entry.reason);
        return _el$5;
      })()
    }));
    return _el$;
  })();
}